import React from "react"
import PropTypes from "prop-types"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import Dispatcher from "../../../../dispatcher"

import Section2 from "./Section2"
import UserI9Store from "../../../../stores/UserI9Store"

const utils = require("../../../../helpers/utils")
const i9Actions = require("../../../../actions/I9Actions")
const userActions = require("../../../../actions/UserActions")
const moment = require("moment")
const propTypes = {
    onClose: PropTypes.func,
    user: PropTypes.object,
    open: PropTypes.bool
}

export default class I9Section2Dialog extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            user: null,
            i9: null
        }

        this.changeEvent = this.changeEvent.bind(this)
        this.handleRequestClose = this.handleRequestClose.bind(this)
    }

    handleRequestSave() {}

    handleRequestClose() {
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    componentDidMount() {
        UserI9Store.on("change", this.changeEvent)
        if (this.props.user) {
            this.loadI9(this.props.user)
        }
    }

    componentWillUnmount() {
        UserI9Store.removeListener("change", this.changeEvent, false)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user) {
            this.loadI9(nextProps.user)
        }

        if (nextProps.open) {
            //When we open the dialog, trigger an update to the user to mark section 2 as started.
            if (this.state.user && this.state.user.I9Status) {
                if (!this.state.user.I9Status.Section2Started) {
                    this.state.user.I9Status.Section2Started = {
                        EventDateTime: moment()
                    }

                    userActions.updateUser(this.state.user.Id, this.state.user)
                }
            }
        }
    }

    changeEvent() {
        this.setState({
            i9: UserI9Store.getI9()
        })
    }

    loadI9(user) {
        if (!this.state.user || this.state.user.Id !== user.Id) {
            i9Actions.loadI9ByUserId(user.Id).then(function(result) {
                if (result) {
                    i9Actions.loadI9Pdf(result.Id)
                }
            })

            this.setState({
                user: user
            })
        }
    }

    validateForm() {}

    render() {
        const standardActions = (
            <div>
                <FlatButton label="Close" secondary={true} onTouchTap={this.handleRequestClose} />
            </div>
        )

        return (
            <div className="I9Section2Dialog-container">
                <Dialog actionsContainerClassName="I9Section2Dialog" open={this.props.open} title="I9 SECTION 2" actions={standardActions} onRequestClose={this.handleRequestClose}>
                    <div style={{ marginTop: -20 }}>
                        <Section2 i9={this.state.i9} />
                    </div>
                </Dialog>
            </div>
        )
    }
}

I9Section2Dialog.propTypes = propTypes
